import jwt_decode from "jwt-decode";

const get = () => {
  const token = localStorage.getItem("token");
  const results = jwt_decode(token);
  return results;
};

export const useTokenPayload = {
  computed: {
    roleFromToken() {
      return get().role;
    },
    idFromToken() {
      return get().id;
    },
    fullnameFromToken() {
      return get().fullname;
    },
    login() {
      return get().login;
    },
    imageNameFromToken() {
      return get().image_name;
    },
  },
};



// WEBPACK FOOTER //
// ./src/_shared/mixins/useTokenPayload.js